import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

// Vertical floating action button on the left edge. Routes to the in-app
// Rebates page (/rebates) covering Service Upgrade and EV Charger rebates.
export default function FloatingRebates() {
  return (
    <Link
      to="/rebates"
      data-testid="floating-rebates-cta"
      aria-label="Check available electrical rebates"
      className="fixed left-0 top-1/2 -translate-y-1/2 z-40 hidden md:flex items-center gap-2 bg-[#E60000] hover:bg-[#FF1A1A] text-white font-bold tracking-[0.28em] uppercase text-xs px-3 py-5 shadow-[0_8px_30px_rgba(230,0,0,0.35)] transition-colors group"
      style={{ writingMode: "vertical-rl", transform: "translateY(-50%) rotate(180deg)" }}
    >
      <span className="inline-flex items-center gap-2">
        <Leaf className="w-4 h-4 shrink-0" strokeWidth={2.5} />
        Check Rebates
      </span>
    </Link>
  );
}
